import React, { useContext, useCallback, useEffect, useState } from "react";
import { Theme, makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import ProjectTable from "../components/project-table";
// import projectList from "../mock-data/project-list";
import ElectricEquip from "../components/electric-equip";
import { MainContext } from "../context/main";
import clsx from "clsx";
import { getProjectDesignsAggregate } from "../apis/project";
import { equipList } from "../constant/equip-options";
// import { LangContext } from "../context/lang";
const useStyle = makeStyles((theme: Theme) => ({
  admin: { height: `calc(100vh - ${theme.spacing(35.75)}px)` },
  staff: { height: `calc(100vh - ${theme.spacing(26.875)}px)` },
  gridHeight: {
    position: "relative",
  },
  gridRightContent: {
    height: `calc(100% + ${theme.spacing(2)}px)`,
    position: "relative",
  },
  subGridTop: {
    height: `calc(50% - ${theme.spacing(1)}px)`,
  },
  subGridBottom: {
    height: `calc(50% + ${theme.spacing(1)}px)`,
  },
}));
interface DepartmentId {
  selectDepartment: string | number;
}
const DashboardUser = (props: DepartmentId) => {
  const classes = useStyle();
  const mainContext = useContext(MainContext);
  const { userInfo } = mainContext;
  // const { lang } = useContext(LangContext);
  const { selectDepartment } = props;

  const [EquipmentList, setEquipmentList] = useState<any>({
    equip_count: 0,
    equip_type: [],
    workFunc: [],
  });
  const initData = useCallback(async (id: string | number) => {
    const abortController = new AbortController();
    //EquipmentList
    const EquipType = await getProjectDesignsAggregate(
      abortController,
      id ? "department_id" : "group",
      id
        ? `${id}&group=designs.source.data.properties.equip_type`
        : "designs.source.data.properties.equip_type"
    ).then((pd: any) => {
      const filterNull = pd.data.filter((fl: any) => fl._id.equip_type);

      const filter = filterNull.filter(
        (fl: any) => !fl._id.equip_type.includes("anno")
      );

      const addLabel = filter.map((fl: any) => {
        const newLabel = equipList.find(
          (ql: any) => ql.type === fl._id.equip_type
        );

        return {
          ...fl,
          _id: { ...fl._id, label: newLabel ? newLabel.id : "" },
        };
      });

      let count = 0;
      filter.map((ct: any) => {
        count = count + ct.count;
        return null;
      });

      return {
        equip_count: count,
        equip_type: addLabel,
      };
    });

    const workFunc = await getProjectDesignsAggregate(
      abortController,
      id ? "department_id" : "group",
      id
        ? `${id}&group=designs.source.data.properties.workFunc`
        : "designs.source.data.properties.workFunc"
    )
      .then((pd: any) => {
        const filter = pd.data.filter((fl: any) => fl._id.workFunc);

        return filter;
      })
      .catch((error: any) => {
        console.log(error);
      });

    const reStuct = { ...EquipType, workFunc: workFunc };

    setEquipmentList(reStuct);
  }, []);

  useEffect(() => {
    initData(selectDepartment);
    return () => {};
  }, [selectDepartment, initData]);

  return (
    <Grid container spacing={2}>
      <Grid
        item
        xs={6}
        className={clsx(
          classes.gridHeight,
          userInfo?.role === "admin" || userInfo?.role === "root"
            ? classes.admin
            : classes.staff
        )}
      >
        <ProjectTable department={selectDepartment} />
      </Grid>
      <Grid
        item
        xs={6}
        className={clsx(
          classes.gridHeight,
          userInfo?.role === "admin" || userInfo?.role === "root"
            ? classes.admin
            : classes.staff
        )}
      >
        <ElectricEquip
          title="Electric Equipment Installed"
          data={EquipmentList}
        />
      </Grid>
    </Grid>
  );
};

export default DashboardUser;
